import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load AlbumDetailPage to reduce initial bundle size
const AlbumDetailPage = lazy(() => import('@/pages/admin/AlbumDetailPage'));

/**
 * Admin album detail route - /admin/albums/:albumId
 * Shows detailed information for a specific album
 */
export const adminAlbumDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'albums/$albumId',
  component: function AlbumDetailWrapper() {
    const { albumId } = adminAlbumDetailRoute.useParams();
    return <AlbumDetailPage albumId={albumId} />;
  },
});

// Backward compatibility
export const Route = adminAlbumDetailRoute;
